/* NSH v5.1 — 결과 화면 변환 (아이콘·용어 강조·케어 묶음·이야기 카드 + 게이트 카피)
   2026-08-27 — 템플릿 인라인 <script> 에서 자산으로 분리.

   왜 분리하나
     템플릿은 한 글자만 고쳐도 24KB 전체를 다시 올려야 한다.
     그럴 때마다 한글이 많은 자리에서 오타가 2~3자씩 생겼다.
     한글 덩어리를 작은 파일로 빼놓으면 템플릿을 건드릴 일이 없고,
     이 파일은 작아서 배포 후 문자열 전수 대조가 쉽다.

   검증법 (배포 뒤 반드시)
     v8.0 렌더 HTML 의 같은 블록과 한글 문자열 집합을 비교한다.
     Shopify 가 자산 JS 를 minify 하고 리터럴을 \uXXXX 로 바꾸므로,
     소스 비교가 아니라 **디코딩 후 문자열 집합**을 대조해야 한다.
     (이 방법으로 씨→씩 같은 바뀜치기를 실제로 잡았다)

   채점 로직 불변. */
(function(){
  function EN(){ return (document.documentElement.lang||'').toLowerCase().indexOf('en')===0; }
  var IC_STOP='<svg class="nsh-ic" viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="#1A1A1A" stroke-width="1.6" aria-hidden="true"><circle cx="10" cy="10" r="8"/><line x1="6.3" y1="10" x2="13.7" y2="10"/></svg>';
  var IC_GO='<svg class="nsh-ic" viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="#1A1A1A" stroke-width="1.6" aria-hidden="true"><circle cx="10" cy="10" r="8"/><path d="M6.3 10.3l2.4 2.4 4.9-5.1"/></svg>';
  var TERMS_KO=['유사세라마이드','세라마이드','피지막','기름막','각질층','장벽 지질','활성 성분','산도(pH)','무기자차','히알루론산','아미노산','피토스테롤','지방산','자외선','세정','실핏줄','pH','장벽'];
  var TERMS_EN=['pseudo-ceramide','ceramides','ceramide','sebum film','oil film','stratum corneum','barrier lipids','active ingredients','active ingredient','mineral sunscreen','hyaluronic acid','amino acids','amino acid','phytosterol','fatty acids','fatty acid','capillaries','cleansing','barrier','pH'];
  function wrapTerms(box){ if(!box) return; var en=EN(); var terms=en?TERMS_EN:TERMS_KO; var used={};
    var w=document.createTreeWalker(box,NodeFilter.SHOW_TEXT,null); var ns=[],n;
    while(n=w.nextNode()){ if(n.parentElement&&!n.parentElement.closest('.term')&&!n.parentElement.closest('.nsh-ic')&&n.nodeValue.trim()) ns.push(n); }
    ns.forEach(function(tn){ var t=tn.nodeValue, tl=t.toLowerCase();
      for(var i=0;i<terms.length;i++){ var k=terms[i]; if(used[k]) continue;
        var idx=en?tl.indexOf(k.toLowerCase()):t.indexOf(k); if(idx<0) continue;
        var real=t.slice(idx,idx+k.length), b=t.slice(0,idx), a=t.slice(idx+k.length);
        var sp=document.createElement('span'); sp.className='term'; sp.textContent=real;
        var f=document.createDocumentFragment(); if(b)f.appendChild(document.createTextNode(b)); f.appendChild(sp); if(a)f.appendChild(document.createTextNode(a));
        tn.parentNode.replaceChild(f,tn); used[k]=1; return; } });
  }
  function roleFor(t){
    if(EN()){ if(/cleans|wash|foam|rinse/i.test(t)) return 'wash'; if(/sunscreen|\bspf\b|\buv\b|\bsun\b/i.test(t)) return 'uv'; if(/cream|balm|oint|seal|barrier/i.test(t)) return 'seal'; if(/serum|hydrat|moist|essence|refill/i.test(t)) return 'hydrate'; return 'care'; }
    if(/씯|닦|클렌|거품/.test(t)) return 'wash'; if(/선크림|자외선|외출|UV/.test(t)) return 'uv'; if(/크림|막|장벽/.test(t)) return 'seal'; if(/채우|세럼|보습|수분/.test(t)) return 'hydrate'; return 'care';
  }
  var ROLE_LABEL={ko:{wash:'세안',hydrate:'보습',seal:'마무리 · 장벽',uv:'자외선',care:'케어'},en:{wash:'Cleanse',hydrate:'Hydrate',seal:'Seal · Barrier',uv:'UV',care:'Care'}};
  var ROLE_ORDER={wash:1,hydrate:2,seal:3,uv:4,care:5};
  function patchGate(){
    var gl=document.querySelector('#result.gated #gateLead'); if(!gl) return;
    var tag=EN()?'en':'ko'; if(gl.getAttribute('data-nshv5')===tag) return; gl.setAttribute('data-nshv5',tag);
    gl.innerHTML = tag==='en'
      ? '<div class="nsh-gh">Your skin has a ritual<br>it needs to keep.</div><p class="nsh-gsub">The full reading for where your skin is now — why it happens, the rituals to try today, and the products that fit. Leave your email and it opens right away.</p>'
      : '<div class="nsh-gh">이 피부가 꼭 지켜야 할<br>비밀의 리추얼이 있어요.</div><p class="nsh-gsub">지금 상태에 딱 맞춘 전체 리딩 — 왜 그런지의 근거부터, 오늘 해볼 리추얼과 내게 맞는 제품까지. 이메일을 남기면 바로 열어드릴게요.</p>';
  }
  function stopIcons(res){ res.querySelectorAll('#dontList .cut-label').forEach(function(el){ if(!el.querySelector('.nsh-ic')) el.insertAdjacentHTML('afterbegin',IC_STOP); }); }
  function transform(){
    var res=document.querySelector('#result'); if(!res) return;
    if(res.classList.contains('gated')){
      patchGate(); var gc=document.getElementById('nshCare'); if(gc) gc.remove();
      stopIcons(res); res.querySelectorAll('#dontList .cut-cap').forEach(wrapTerms); return;
    }
    var slots=res.querySelector('#slots'); if(!slots||!slots.children.length) return;
    stopIcons(res);
    res.querySelectorAll('#slots .slot-how').forEach(function(el){ if(!el.querySelector('.nsh-ic')) el.insertAdjacentHTML('afterbegin',IC_GO); });
    res.querySelectorAll('#dontList .cut-cap, #slots .slot-why').forEach(wrapTerms);
    if(res.querySelectorAll('#slots .slot .prod').length){
      var lang=EN()?'en':'ko';
      var old=document.getElementById('nshCare'); if(old) old.remove();
      var slotSec=res.querySelector('#slotSec');
      var care=document.createElement('section'); care.id='nshCare'; care.className='rx';
      care.innerHTML='<h3 class="shead"><span class="sn">03</span>'+(lang==='en'?'Care that fits you now':'내게 맞는 케어')+'</h3>';
      var wrap=document.createElement('div'); wrap.className='nsh-prods'; care.appendChild(wrap);
      res.querySelectorAll('#slots .slot .prod').forEach(function(prod){
        var slot=prod.closest('.slot'); var how=((slot&&slot.querySelector('.slot-how'))||{}).textContent||'';
        var main=prod.querySelector('.prod-main');
        if(main&&!main.querySelector('.nsh-prole')){ var role=(slot&&slot.getAttribute('data-role'))||roleFor(how); var pr=document.createElement('div'); pr.className='nsh-prole'; pr.setAttribute('data-role',role); pr.textContent=ROLE_LABEL[lang][role]; main.insertBefore(pr,main.firstChild); }
        wrapTerms(prod.querySelector('.prod-why')); wrap.appendChild(prod);
      });
      [].slice.call(wrap.children).sort(function(a,b){
        var pa=a.querySelector('.nsh-prole'), pb=b.querySelector('.nsh-prole');
        var ra=pa?(pa.getAttribute('data-role')||'care'):'care', rb=pb?(pb.getAttribute('data-role')||'care'):'care';
        return (ROLE_ORDER[ra]||9)-(ROLE_ORDER[rb]||9);
      }).forEach(function(c){ wrap.appendChild(c); });
      var disc=res.querySelector('#slotDisclose'); if(disc) care.appendChild(disc);
      var pnote=res.querySelector('#prodNote'); if(pnote) care.appendChild(pnote);
      if(wrap.children.length) slotSec.parentNode.insertBefore(care, slotSec.nextSibling);
    }
    var arts=res.querySelector('#arts');
    if(arts && !arts.querySelector('.nsh-reads')){
      var reals=[].slice.call(arts.querySelectorAll('a')).filter(function(a){ var tg=a.getAttribute('data-tag')||''; return tg.indexOf('-more')<0&&(a.textContent||'').replace(/[「」\s]/g,'').length>4; });
      if(reals.length){ var list=document.createElement('div'); list.className='nsh-reads';
        reals.forEach(function(a){ var cd=document.createElement('a'); cd.className='nsh-read'; cd.href=a.getAttribute('href')||'#'; cd.target='_blank'; cd.rel='noopener'; cd.innerHTML='<span class="rt">'+(a.textContent||'').replace(/[「」]/g,'').trim()+'</span><span class="arw">→</span>'; list.appendChild(cd); });
        arts.appendChild(list); }
    }
  }
  function boot(){
    var t=null, mo=null;
    function run(){ if(mo) mo.disconnect(); try{ transform(); }catch(e){} if(mo){ try{ mo.observe(document.body||document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class']}); }catch(e){} } }
    mo=new MutationObserver(function(){ clearTimeout(t); t=setTimeout(run,60); });
    try{ mo.observe(document.body||document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class']}); }catch(e){}
    setTimeout(run,150);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
